import { MapCreator } from '../../../../utils/map-creator';
import { DestinationSubDocument } from '../destination/sub-document/destination-sub-document';
export const characterPropertiesKeywords = new MapCreator()
    .add("deleted", DestinationSubDocument.onDeletedKeyword)
    .add("b", DestinationSubDocument.onBoldKeyword)
    .add("i", DestinationSubDocument.onItalicKeyword)
    .add("ul", DestinationSubDocument.onUnderlineSingleKeyword)
    .add("uld", DestinationSubDocument.onUnderlineDottedKeyword)
    .add("uldash", DestinationSubDocument.onUnderlineDashedKeyword)
    .add("uldashd", DestinationSubDocument.onUnderlineDashDottedKeyword)
    .add("uldashdd", DestinationSubDocument.onUnderlineDashDotDottedKeyword)
    .add("uldb", DestinationSubDocument.onUnderlineDoubleKeyword)
    .add("ulhwave", DestinationSubDocument.onUnderlineHeavyWaveKeyword)
    .add("ulldash", DestinationSubDocument.onUnderlineLongDashedKeyword)
    .add("ulth", DestinationSubDocument.onUnderlineThickSingleKeyword)
    .add("ulthd", DestinationSubDocument.onUnderlineThickDottedKeyword)
    .add("ulthdash", DestinationSubDocument.onUnderlineThickDashedKeyword)
    .add("ulthdashd", DestinationSubDocument.onUnderlineThickDashDottedKeyword)
    .add("ulthdashdd", DestinationSubDocument.onUnderlineThickDashDotDottedKeyword)
    .add("ulthldash", DestinationSubDocument.onUnderlineThickLongDashedKeyword)
    .add("ululdbwave", DestinationSubDocument.onUnderlineDoubleWaveKeyword)
    .add("ulwave", DestinationSubDocument.onUnderlineWaveKeyword)
    .add("ulw", DestinationSubDocument.onUnderlineWordsOnlyKeyword)
    .add("ulnone", DestinationSubDocument.onUnderlineNoneKeyword)
    .add("ulc", DestinationSubDocument.onUnderlineColorKeyword)
    .add("strike", DestinationSubDocument.onStrikeoutKeyword)
    .add("striked", DestinationSubDocument.onDoubleStrikeoutKeyword)
    .add("sub", DestinationSubDocument.onSubscriptKeyword)
    .add("super", DestinationSubDocument.onSuperscriptKeyword)
    .add("nosupersub", DestinationSubDocument.onNoSuperAndSubScriptKeyword)
    .add("lang", DestinationSubDocument.onLanguageKeyword)
    .add("langfe", DestinationSubDocument.onLanguageEastAsianKeyword)
    .add("langfenp", DestinationSubDocument.onLanguageEastAsianNpKeyword)
    .add("langnp", DestinationSubDocument.onLanguageNpKeyword)
    .add("noproof", DestinationSubDocument.onNoProofKeyword)
    .add("caps", DestinationSubDocument.onCapsKeyword)
    .add("scaps", DestinationSubDocument.onSmallCapsKeyword)
    .add("v", DestinationSubDocument.onHiddenTextKeyword)
    .add("fs", DestinationSubDocument.onFontSizeKeyword)
    .add("f", DestinationSubDocument.onFontNameKeyword)
    .add("af", DestinationSubDocument.onAssociatedFontNameKeyword)
    .add("cf", DestinationSubDocument.onForeColorKeyword)
    .add("highlight", DestinationSubDocument.onHighlightColorKeyword)
    .add("chshdng", DestinationSubDocument.onShadingKeyword)
    .add("chbghoriz", DestinationSubDocument.onHorizontalBackgroundPatternKeyword)
    .add("chbgvert", DestinationSubDocument.onVerticalBackgroundPatternKeyword)
    .add("chbgfdiag", DestinationSubDocument.onForwardDiagonalBackgroundPatternKeyword)
    .add("chbgbdiag", DestinationSubDocument.onBackwardDiagonalBackgroundPatternKeyword)
    .add("chbgcross", DestinationSubDocument.onCrossBackgroundPatternKeyword)
    .add("chbgdcross", DestinationSubDocument.onDiagonalCrossBackgroundPatternKeyword)
    .add("chbgdkhoriz", DestinationSubDocument.onDarkHorizontalBackgroundPatternKeyword)
    .add("chbgdkvert", DestinationSubDocument.onDarkVerticalBackgroundPatternKeyword)
    .add("chbgdkfdiag", DestinationSubDocument.onDarkForwardDiagonalBackgroundPatternKeyword)
    .add("chbgdkbdiag", DestinationSubDocument.onDarkBackwardDiagonalBackgroundPatternKeyword)
    .add("chbgdkcross", DestinationSubDocument.onDarkCrossBackgroundPatternKeyword)
    .add("chbgdkdcross", DestinationSubDocument.onDarkDiagonalCrossBackgroundPatternKeyword)
    .add("chcfpat", DestinationSubDocument.onFillColorKeyword)
    .add("chcbpat", DestinationSubDocument.onBackColorKeyword)
    .add("dbch", DestinationSubDocument.onDoubleByteCharactersKeyword)
    .add("loch", DestinationSubDocument.onLowAnsiFontNameKeyword)
    .add("hich", DestinationSubDocument.onHighAnsiFontNameKeyword)
    .add("rtlch", DestinationSubDocument.onRTLRunKeyword)
    .add("ltrch", DestinationSubDocument.onLTRRunKeyword)
    .get();
